import { I18n, i18n } from "@lingui/core";
import { Language } from "../src/utils/localization/languages/types";
import * as plurals from "make-plural/plurals";

export function activateI18n(language: Language): I18n {
  const languageCode = language.code;
  const pluralsCode = languageCode.slice(0, 2);
  // const { messages } = await import(
  //   `../src/locales/${languageCode}/messages.mjs`
  // );
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const messages = require(`../src/locales/${languageCode}/messages.mjs`)
    .messages;
  // const { messages } = await import(
  //   `../../locales/${languageCode}/messages.mjs`
  // );
  //const i18n = setupI18n({ [languageCode]: messages });

  i18n.loadLocaleData(languageCode, { plurals: plurals[pluralsCode] });
  i18n.load(languageCode, messages);
  i18n.activate(languageCode);
  return i18n;
}
